import { useStore } from '../context/StoreContext';
import { useTheme } from '../shared/hooks/useTheme';
import { Icon } from '../shared/ui/Icon';

export function MobileTabbar() {
  const { page, cartCount, user, go, browseCategory, showAccount } = useStore();
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="mobile-tabbar" aria-label="Mobile navigation">
      <button className={page === 'home' ? 'active' : ''} onClick={() => go('home')}>
        <Icon>⌂</Icon><span>Home</span>
      </button>
      <button className={page === 'catalog' ? 'active' : ''} onClick={() => browseCategory()}>
        <Icon>▦</Icon><span>Explore</span>
      </button>
      <button className={page === 'cart' ? 'active' : ''} onClick={() => go('cart')}>
        <Icon>▱</Icon><span>Bag{cartCount > 0 ? ` (${cartCount})` : ''}</span>
      </button>
      <button className={page === 'account' ? 'active' : ''} onClick={showAccount}>
        <Icon>♙</Icon><span>Account</span>
      </button>
      {user?.role === 'admin' ? (
        <button className={page === 'admin' ? 'active' : ''} onClick={() => go('admin')}>
          <Icon>👑</Icon><span>Admin</span>
        </button>
      ) : (
        <button onClick={toggleTheme}>
          <Icon>{theme === 'dark' ? '☼' : '◐'}</Icon>
          <span>{theme === 'dark' ? 'Light' : 'Dark'}</span>
        </button>
      )}
    </nav>
  );
}
